import React, { useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

import { updateManagerAssistantSetting } from 'Shared/actions/user';
import { managerAssistantSettingType } from 'Shared/constants/constants';
import RecurrenceSettingsInput from 'Dashboard/components/RecurrenceSettingsInput/RecurrenceSettingsInput';

import WpAlert from 'Wpds/components/alert/WpAlert';
import AssistantsManagerSettingsPanel from '../AssistantsManagerSettingsPanel/AssistantsManagerSettingsPanel';
import './GiveKudosPrompt.scss';

const recurrenceIntervalOptions = [{ value: 'week', label: 'Week(s)' }];

function GiveKudosPrompt() {
  const dispatch = useDispatch();

  const managerAssistantSetting = useSelector(state => {
    const { managerAssistantSettings } = state;
    if (!managerAssistantSettings.length) return null;
    return managerAssistantSettings.find(({ type }) => type === managerAssistantSettingType.GiveRecognition);
  });

  const initValues = {
    recurrenceAmount: managerAssistantSetting?.recurrence?.intervalAmount,
    recurrenceInterval: managerAssistantSetting?.recurrence?.intervalUnit,
  };

  const [formValues, setFormValues] = useState(initValues);

  const recurrenceIntervalOption = recurrenceIntervalOptions.find(
    ({ value }) => value === formValues.recurrenceInterval
  );

  const handleActiveToggleChange = () => {
    dispatch(updateManagerAssistantSetting(managerAssistantSetting.id, { active: !managerAssistantSetting.active }));
  };

  const handleRecurrenceAmountChange = event =>
    setFormValues({ ...formValues, recurrenceAmount: parseInt(event.target.value || 1, 10) });
  const handleRecurrenceIntervalChange = option => setFormValues({ ...formValues, recurrenceInterval: option.value });
  const handleCancelClick = () => setFormValues(initValues);

  const handleSubmitClick = () => {
    const formValuesTransformed = {
      recurrence_attributes: {
        id: managerAssistantSetting.recurrence.id,
        interval_unit: formValues.recurrenceInterval,
        interval_amount: formValues.recurrenceAmount,
      },
    };
    dispatch(updateManagerAssistantSetting(managerAssistantSetting.id, formValuesTransformed));
  };

  if (!managerAssistantSetting) return null;

  return (
    <AssistantsManagerSettingsPanel
      index={2}
      title="Give Kudos Prompt"
      shortDescription="In-app prompts your team to give each other kudos."
      isActive={managerAssistantSetting.active}
      onActiveChange={handleActiveToggleChange}
      onCancelClick={handleCancelClick}
      onSubmitClick={handleSubmitClick}
      formChanged={!isEqual(formValues, initValues)}
    >
      <>
        <div className="give-kudos-prompt-title mb-2">How often do you want the team to be prompted to give kudos?</div>
        <div className="d-flex align-items-center mb-3">
          <RecurrenceSettingsInput
            label="Every"
            amountValue={formValues.recurrenceAmount}
            intervalValue={recurrenceIntervalOption.value}
            intervalOptions={recurrenceIntervalOptions}
            onAmountValueChange={handleRecurrenceAmountChange}
            onIntervalValueChange={handleRecurrenceIntervalChange}
          />
        </div>
        <div className="mb-4">
          <WpAlert type="info" showIcon={false}>
            Each team member will be prompted to give kudos to the person who has gone the longest without a kudos from
            them.
          </WpAlert>
        </div>
      </>
    </AssistantsManagerSettingsPanel>
  );
}

export default memo(GiveKudosPrompt);
